import moment from 'moment';
import { format } from 'date-fns';
// eslint-disable-next-line import/prefer-default-export
export function stageTime(time) {
  if (moment(time).isValid()) {
    return moment(time).format('D/M/YYYY');
  }
  return '';
}

export function groupTime(time) {
  if (moment(time).isValid()) {
    return moment(time).locale('en').format('hh:mm A');
  }
  return '';
}

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function commonDate(time) {
  return time ? moment(time).format('YYYY-M-D') : '';
}
